// external
import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";

// components
import PublishedModel from "components/PublishedModel";
import Loader from "components/partials/loader/loader";

// state managing
import { FaoBuilderContext } from "context/FaoBuilderContext";

// assets
import Icons from "../../assets/icons";

function FaoEdit() {
  const { fetchModels } = useContext(FaoBuilderContext);
  // const [models, setModels] = useState([]);
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  useEffect(() => {
    fetchModels(setIsLoading, setError, setModels, "published");
  }, []);

  return (
    <div className="flex min-h-full w-full flex-col">
      <div className="w-full">
        <div className="mb-8">
          <h2 className="text-2xl font-semibold text-blue-03">
            Published FAO Models
          </h2>
          <div className="flex">
            <Icons.Info customClass="h-4 w-4 text-gray-500 mr-1 mt-1" />
            <p className="text-gray-500">
              This page allows you to view all published FAO models and aid
              results. If the aid results are not generated, you can build them
              by clicking the build button.
            </p>
          </div>
        </div>
        {isLoading ? (
          <Loader />
        ) : error || (!isLoading && models.length === 0) ? (
          <div className="flex h-64 items-center justify-center">
            <p
              className={classNames({
                "text-red-500": error,
                "text-gray-500": isLoading,
              })}
            >
              {error || "No published models found"}
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 gap-6">
            {models.map((item) => {
              return (
                <PublishedModel
                  key={item.id}
                  model={item}
                  setModels={setModels}
                  models={models}
                />
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default FaoEdit;
